// extracted by mini-css-extract-plugin
export default {"contextMenu":"ContextMenu_contextMenu__aVtdK"};